import * as api from "services/api";

import _ from "lodash";
import { isValidNumber } from "libphonenumber-js";

import history from "../../../../history";

export const EDIT_BUDGET = "[BUDGET EDIT] EDIT_BUDGET";
export const EDIT_BUDGET_SUCCESS = "[BUDGET EDIT] EDIT_BUDGET_SUCCESS";
export const EDIT_BUDGET_FAILED = "[BUDGET EDIT] EDIT_BUDGET_FAILED";

export const GET_BUDGET = "[BUDGET EDIT] GET_BUDGET";
export const GET_BUDGET_SUCCESS = "[BUDGET EDIT] GET_BUDGET_SUCCESS";
export const GET_BUDGET_FAILED = "[BUDGET EDIT] GET_BUDGET_FAILED";

export const SET_VALUE = "[BUDGET EDIT] SET_VALUE";
export const CLEAR_VALUE = "[BUDGET EDIT] CLEAR_VALUE";

export function getBudget(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_BUDGET
    });

    const { token } = getState().login;

    let response = await api.sendGet("/budget/" + id, {
      Authorization: "Bearer " + token
    });

    if (response.ok) {
      let json = await response.json();

      let budget = json.model;
      dispatch({
        type: GET_BUDGET_SUCCESS,
        payload: budget
      });
    } else {
      dispatch({ type: GET_BUDGET_FAILED });
    }
  };
}

export function editBudget() {
  return async (dispatch, getState) => {
    dispatch({
      type: EDIT_BUDGET
    });

    const { login, budgetEdit } = getState();

    let {
      item,
      clientId,
      phoneNumber,
      people,
      mount,
      discount,
      startDate,
      endDate,
      deliveryType,
      deliveryAddress,
      city,
      deliveryCityId,
      moreInfo
    } = budgetEdit;

    const errors = {};

    if (phoneNumber && !isValidNumber(phoneNumber)) {
      errors.phoneNumber = "Telefone inválido";
    }

    if (people < 1) {
      errors.people = "Campo inválido";
    }

    if (deliveryType === 1 && !deliveryAddress) {
      errors.deliveryAddress = "Campo obrigatório";
    }

    dispatch(
      setValue({
        errors
      })
    );

    if (_.keys(errors).length > 0) return dispatch({ type: EDIT_BUDGET_FAILED });

    let response = await api.sendPut(
      "/budget/" + item.id,
      {
        ...item,
        phoneNumber,
        people,
        clientId,
        mount,
        discount,
        startDate,
        endDate,
        deliveryType,
        deliveryCityId,
        deliveryAddress,
        city,
        moreInfo
      },
      {
        Authorization: "Bearer " + login.token
      }
    );

    if (response.ok) {
      const result = await response.json();

      dispatch({
        type: EDIT_BUDGET_SUCCESS
      });

      dispatch(clearValue());

      history.push("/budgets/" + result.model.id);
    } else {
      dispatch({ type: EDIT_BUDGET_FAILED });
    }
  };
}

export function setValue(payload) {
  return {
    type: SET_VALUE,
    payload
  };
}

export function clearValue() {
  return {
    type: CLEAR_VALUE
  };
}
